import React, { useCallback, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import { base, LabelContainer, Label, Leading } from './style'
import Maskarade from './mask'

function InputComponent({label, required, leftIcon, rightIcon, onChange, mask, model, format, ...rest}) {
    const [error, setError] = useState(false) 
    const validate = useCallback((e) => {
        if(e.target.value === "") {
            setError(true)
        } else {
            setError(false)
        }
    }, [])

    useEffect(() => {
        if(!model) return

        model.ref.current = {
            error: () => {
                setError(true)
            }
        }
    }, [])


    const change = useCallback(e => {
        if(mask) {
            e.target.value = Maskarade(e.target.value, mask)
        }

        if(format && e.target.value) {
            e.target.value = format(e.target.value)
        }

        if(onChange) {
            onChange(e)
        }

        if(model) {
            model.onChange(e)
        }
    }, [])

    return (
        <LabelContainer>
            <Label>{label}</Label>
            {leftIcon && <Leading>{leftIcon()}</Leading>}
            {rightIcon && <Leading right>{rightIcon()}</Leading>}
            <Input
                error={error} 
                onBlur={required && validate}
                onKeyUp={error ? validate : null}
                onChange={change}
                value={model ? model.value : undefined}
                name={model ? model.name : ""}
                {...rest}
            />
        </LabelContainer>
    )
}

const Input = styled.input`
    ${base}
    ${props => props.error && css`
        border: 1px solid #FF0000;
    `}
    ${props => props.rtl && css`
        text-align: right;
    `}
`

export default InputComponent


// WEBPACK FOOTER //
// ./src/SPRINTA/v3/Form/InputText.js